import { dynamicRangeDiscountInputSchema } from "@redotech/redo-model/discount/discount-db-parser";
import { marketingAgentSplitZodSchema } from "@redotech/redo-model/split";
import * as z from "zod/v4";

export const startMarketingAgentTest = {
  name: "startMarketingAgentTest" as const,
  input: marketingAgentSplitZodSchema
    .pick({ cooldownHours: true, discountProclivity: true })
    .extend({
      variantTrafficPercentage: z.number().min(0).max(100),
      discountConfig: dynamicRangeDiscountInputSchema.optional(),
    }),
  output: z.object({ splitId: z.string() }),
};
